import React from "react";
import CTable from "components/common/Table";
import { withRouter } from "react-router";

const LeadsList = ({ data, loading }) => {
  const columns = [
   
    {
      field: "first_name",
      headerName: "Name",
    },
    {
      field: "utm_source",
      headerName: "UTM Source",
    },
    {
      field: "utm_campaign",
      headerName: "UTM Camp",
    },
    {
        field: "created_at",
        headerName: "Lead Date",
      },
     
      {
        field: "registered",
        headerName: "Registration Y/N",
        valueGetter: (v, d) => {
       
          return (
            <>
             {d.registered ? "Yes" : "No"}
            </>
          );
        },
      },
      {
        field: "email",
        headerName: "Email",
      },
      {
        field: "mobile",
        headerName: "Mobile Number",
      },
      {
        field: "pin",
        headerName: "Pin Code",
      },
     
  ];

  return (
    <CTable
      columns={columns}
      data={data}
      isLoading={loading?.isLoading}
      pagination={true}
      localPagination={true}
      page={0}
      rowsPerPage={5}
    ></CTable>
  );
};

export default withRouter(LeadsList);
